import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TradingService } from '../trading.service';
import { AuthService } from '@service/auth.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'trading-subscription-dialog',
    templateUrl: './subscription-dialog.component.html',
    styleUrls: ['./subscription-dialog.component.scss']
})
export class TradingSubscriptionDialogComponent implements OnInit {

    makePayment: boolean = false;
    subscriptionPlanData: any[] = [];
    selectedPlan: any
    trialEligible: boolean = false;
    isExpired: boolean = false;
    category: string = 'cash'
    page: number = 1
    isLoggedIn: boolean = false
    isLoading: boolean = false
    currentUser: any;
    isTrial: boolean = false
    // pickrightAdvisor: any
    // isPickrightAdvisor: boolean = false

    constructor(
        private dialogRef: MatDialogRef<TradingSubscriptionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router,
        private tradeService: TradingService,
        private authService: AuthService
    ) { }

    ngOnInit(): void {        
        this.authService.isLoggedIn.subscribe((res) => this.isLoggedIn = res)
        this.authService.userProfile.subscribe(res => this.currentUser = res)
        if (this.data) {            
            // this.getSubscriptionPlans()
            this.getSubscriptionPlanData(this.data._id)
        }
    }
    ngOnDestroy() {
    }

    getSubscriptionPlanData(packId:any){
        this.isLoading = true
        this.tradeService.getSubscriptionPlanData(packId).pipe(finalize(() => this.isLoading = false)).subscribe({
            next: (res:any)=>{
                this.subscriptionPlanData = res
                this.selectedPlan = this.subscriptionPlanData.find((plan) => plan.duration === '3M')
                const isTrail = this.subscriptionPlanData.findIndex((x) => x.isTrial) > -1
                if (isTrail) {
                    this.trialEligible = !this.data.subscriptionInfo && !this.data.currentPlan                    
                }                
                this.isExpired = this.data.currentPlan && this.data.currentPlan.status === 'EXPIRED'
            }
        })
    }

    // getSubscriptionPlans() {
    //     this.isLoading = true
    //     this.tradeService.getSubscriptionPlans(this.data._id).pipe(finalize(() => this.isLoading = false)).subscribe((res: any) => {
    //         this.subscriptionPlanData = res
    //         this.selectedPlan = this.subscriptionPlanData.find((plan) => plan.duration === '3M')
    //         const isTrail = this.subscriptionPlanData.findIndex((x) => x.isTrial) > -1
    //         if (isTrail) {
    //             this.trialEligible = !this.data.subscriptionInfo && !this.data.currentPlan
    //         }
    //         this.isExpired = this.data.currentPlan && this.data.currentPlan.status === 'EXPIRED'
    //     })
    // }
    close() {
        this.dialogRef.close()
    }

    goToSubscription(plan?) {
        if (this.isLoggedIn) {
            if (plan) {
                this.selectedPlan = plan
            }
            this.close()
            if (this.isLoggedIn && !this.currentUser.rewardBenefits.benefitsReceived.adminOfferPaidSubscription && !this.isTrial && !this.currentUser.couponCode && !this.currentUser.referredCode) {
                window.localStorage.setItem('paidOfferAvail', 'true')
            }
            window.localStorage.setItem('tradingRenew', JSON.stringify(this.data))
            this.router.navigateByUrl(`/trading/subscription-flow?advisor=${this.selectedPlan.advisor._id}&plan=${this.selectedPlan._id}&packId=${this.data._id}`)   
        }
        else {
            this.close()
            window.localStorage.setItem('loginRequired', "true");
            this.router.navigate(['/login'])
        }
    }
}
